let AitiCoreValidatorPostCode = {

    'default': function(value, length) {
        length = length || 5;
        return new RegExp('^[0-9]{' + length + '}$').test(value) ? value : null;
    },

    'CZ': function(value) {
        if (!AitiCoreValidatorPostCode['default'](value, 5)) {
            return null;
        }

        if (value[0] < '1' || value[0] > '7') {
            return null;
        }

        return value;
    },

    'SK': function(value) {
        if (!AitiCoreValidatorPostCode['default'](value, 5)) {
            return null;
        }

        if (value[0] != '8' && value[0] != '9' && value[0] != '0') {
            return null;
        }

        return value;
    },

    'PL': function(value) {
        if (!AitiCoreValidatorPostCode['default'](value, 5)) {
            return null;
        }

        return value.substr(0, 2) + '-' + value.substr(2);
    },

    'BA': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 5);
    },

    'BG': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 4);
    },

    'HR': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 5);
    },

    'RS': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 5);
    },

    'HU': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 4);
    },

    'RO': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 6);
    },

    'RU': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 6);
    },

    'SI': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 4);
    },

    'TR': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 5);
    },

    'UA': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 5);
    },

    'IT': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 5);
    },

    'ME': function(value) {
        return AitiCoreValidatorPostCode['default'](value, 5);
    },
};

export default AitiCoreValidatorPostCode;
